import { createHelpPage, createPageHelpers, createPaytablePage } from "@spawn/nrg-games-core";

export const pageHelpers = createPageHelpers({
	packageName: "flor-de-muerto",
	goldenBonusImage: "top_reveal.png",
	bonusBanner: "bonus_all.png",
	freegameReelsBanner: "fg_reels.png",
});

export const HelpPage = createHelpPage(pageHelpers, "title.fdm");
export const PaytablePage = createPaytablePage(pageHelpers);
